import moment from 'moment-timezone';
import isEmpty from 'lodash.isempty';

import { clientTypeFPS, consentUrls, groupStatus } from "./components/shared/Content";
import { GENERAL_HUB_ERROR_MODAL, HUB_GENERAL_ERROR_OVERLAY } from './Constants';
import { dispatchOverlayLoad } from './components/shared/Analytics';

export const momentNowEstDate = moment().tz('America/New_York').set({ hour: 0, minute: 0, second: 0, millisecond: 0 });

export const resetMgpTimer = () => {
    const iframeMGP = document.getElementsByName('mgp_iframe');
    if (iframeMGP.length) {
        iframeMGP[0].contentWindow.postMessage(JSON.stringify({ resetSessionTimeout: true }), '*');
        console.log(console.log("MGP iframe timer reset"));
    }
}

export const setLastRequestTime = () => {
    localStorage.setItem('lastRequestTime', moment().format('x'));
    resetMgpTimer();
};

export const closeModal = (id) => {
    const modal = document.getElementById(id);
    if (modal?.open) {
        modal?.close();
    }
};

export const listStyle = {
    margin: '0px',
    listStyle: 'inherit',
    listStylePosition: 'outside',
    position: 'relative',
    padding: '8px 0 8px 16px'
}

export const showModal = (id) => {
    setTimeout(() => {
        const modal = document.getElementById(id);
        if (modal && modal?.open === false) {
            try {
            const shadowRoot = modal?.shadowRoot;
            const contentZone = shadowRoot?.querySelector('.modal-content-zone')
            contentZone?.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
                modal?.show()
            } catch (e) {
                log(console.log(e));
            }
        }
    }, 100)
}
const getEmailInv = sessionStorage.getItem('emailInv');
export const encodedUrlText = getEmailInv && !isEmpty(JSON.parse(sessionStorage.getItem('emailInv'))) ? JSON.parse(sessionStorage.getItem('emailInv')).encodedUrlText : null;

// To Do replace encodedUrlText with encodedUrlTextNew() in all refs for next release
// Method to get the reset value of encodedURlText - As now we are resetting the value based on URLs
export const encodedUrlTextNew = () => {
    const emailInvConditions = sessionStorage.getItem('emailInv') && !isEmpty(JSON.parse(sessionStorage.getItem('emailInv')))
    return emailInvConditions ? JSON.parse(sessionStorage.getItem('emailInv')).encodedUrlText : null;
}

export const addCoClientEligible = (
    clientType,
    activeConsent,
    isPrimary,
    numberOfClients,
    checkConsent,
    status
) => {
    const checkForPrimary =
        checkConsent && clientType !== clientTypeFPS.COCLIENT
            ? true
            : isPrimary;
    return (
        checkForPrimary &&
        (status === groupStatus.CONSENT_GIVEN ||
            status === groupStatus.APPOINTMENT_NEEDED ||
            status === groupStatus.APPOINTMENT_SCHEDULED
        ) &&
        numberOfClients <= 1 &&
        checkConsent &&
        activeConsent
    );
};

// consent valid on exp date
export const itemIsExpired = (expirationDate) =>
    expirationDate &&
    momentNowEstDate.isAfter(
        moment.tz(expirationDate, 'America/New_York').subtract(1, 'days'));

const hasActiveConsent = (currentClientData) => !isEmpty(currentClientData?.activeConsent)
export const isRasStatus = (status, currentClientData) => (
    (status === groupStatus.IMPLEMENTED || status === groupStatus.FUNDING || status === groupStatus.COMPLETED)
    && hasActiveConsent(currentClientData)
) || (status === groupStatus.COMPLETED && !hasActiveConsent(currentClientData));

export const dateFormatter = (date, format) => moment(date).format(format);
const basePath = '/usis/advice/fps';

export const isConsentUrl = () => Boolean(
    consentUrls.filter(
        p => window.location.pathname === basePath + p
    ).length > 0
);

export const openPDFLink = (link) => e => {
    e.preventDefault();
    setLastRequestTime();
    window.open(link);
};

export const showYodleeModal = (state) => (window.sessionStorage.getItem("showYodleeModal") === null) && state?.yodleeResponse?.yodleeErrorStatus;

export const isJson = (jsonObject) => {
    let item;
    try {
        item = JSON.parse(jsonObject);
    } catch (e) {
        console.log(e);
        return false;
    }

    return (typeof item === "object" && item !== null);
};

export async function log(children) {
    const isProd = window?.location?.hostname.includes('www.troweprice.com') || window?.location?.hostname.includes('www.awstrp.net');

    if (!isProd && import.meta.env.TEST !== 'true') {
        return { children }
    }

    return null;
}

export const doesNotInclude = (container, value) => {
    let returnValue = false;
    const hasValue = container.indexOf(value);
    if (hasValue < 0) {
        returnValue = true;
    }
    return returnValue;
};

export const matchPathname = (pathsList) => pathsList.filter(p => window.location.pathname === p);

export const getFinancialAccounts = (accounts, type) => accounts.map(account => {
    const getAccountOwners = (parties) => parties?.filter(party => ["TTEE", "OWNR"].includes(party.role))?.map(party => party?.entity?.fullName);
    const getOwners = () => {
        if (getAccountOwners(account?.agreementParties)?.length > 0) {
            return getAccountOwners(account?.agreementParties);
        }
        if (account?.owners?.length > 0) {

            return account.owners
        }
        return ['']
    }
    return {
        type,
        accountType: account?.agreementTypeValue?.displayName
            || account?.agreementTypeValue?.enumerationName
            || account.accountType
            || account?.agreementKey?.productType?.enumerationName,
        amount: account?.balanceSummary?.marketValue || account?.balanceSummary?.availableEquity || account.amount,
        owners: getOwners(),
        agreementNumber: account?.agreementKey?.agreementNumber || account.agreementNumber
    }
});


export const setCookie = (cname, cvalue, exdays, isInternal) => {
    const d = new Date();
    const getDomain = isInternal ? '.awstrp.net' : '.troweprice.com';
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = `${cname}=${cvalue};${expires};domain=${getDomain};path=/`;
}

export const getCookie = (cname) => {
    const name = cname + "=";
    const ca = document.cookie.split(';');
    for (const c of ca) {
        const trimmed = c.trim(); // Removes leading/trailing spaces
        if (trimmed.startsWith(name)) {
            return trimmed.substring(name.length, trimmed.length);
        }
    }
    return null;
}


export const getParamCookie = document.cookie.match('(^|;)\\s*from\\s*=\\s*([^;]+)')?.pop() || '';
export const queryParam = new URLSearchParams(window.location.search).get('from');

export const getIsRasHH = (planningGroup, engagementStatus) => {
    const getRASPastEngagements = planningGroup?.pastEngagements?.filter(word => word.engagementType === 'RAS-Onboarding' || word.engagementType === 'Advice-Express Path');
    const getRASCompletedStatus = getRASPastEngagements?.filter(word => word.engagementStatus.status === 'CMPD');

    return ((!isEmpty(getRASPastEngagements) && !isEmpty(getRASCompletedStatus)) || (!isEmpty(engagementStatus) && engagementStatus.status === 'CMPD'));
}

const RAS_REVIEW = 'ras-review';
const ADD_ACCOUNT = 'add-account';

export const commonErrorPromise = (error) => Promise.resolve(error)
    .then(() => showModal(GENERAL_HUB_ERROR_MODAL))
    .then(() => console.log(error))
    .then(() => dispatchOverlayLoad(HUB_GENERAL_ERROR_OVERLAY))
    .then(() => setLastRequestTime())

export const engagementType = (isRasHousehold) => {
console.log('cookie:', getParamCookie, queryParam)
    if (isRasHousehold) {
        if (queryParam === RAS_REVIEW || getParamCookie === RAS_REVIEW) {
            return 'RAS_REVIEW'
        }

        if ((queryParam === ADD_ACCOUNT || getParamCookie === ADD_ACCOUNT)) {
            return 'RAS_ADD_ACCOUNT'
        }
        return 'RAS_REVIEW'
    }
    return 'RAS_ONBOARDING';
}

export const getAnalyticsActiveEngagement = (planningGroup) => {
    if (planningGroup?.clients) {
        const primaryClient = planningGroup.clients.filter(client => client.clientType === 'PRIMARY')[0];
        const hasActiveEngagement = planningGroup?.activeEngagement !== null;

        if (primaryClient?.activeConsent) {
            // check that user has a current engagement (aka consent for primary client is active)
            if (!hasActiveEngagement) {
                return null;
            }
            return planningGroup.activeEngagement;
        }
        if (planningGroup?.activeEngagement) {
            return planningGroup.activeEngagement
        }
        return null;
    }
    return null;
}

export const getAnalyticsEngagementType = (activeEngagement) => {
    // check query params for redirects for RAS-Review or RAS-Add-Account RJ experiences
    if (queryParam === RAS_REVIEW || getParamCookie === RAS_REVIEW) {
        return 'RAS-Review'
    }

    if ((queryParam === ADD_ACCOUNT || getParamCookie === ADD_ACCOUNT)) {
        return 'RAS-Add Account'
    }

    if (activeEngagement) {
        return activeEngagement.engagementType;
    }
    return null;
}

export const getAnalyticsEngagementStatus = (activeEngagement) => {
    if (activeEngagement) {
        if (activeEngagement.engagementStatus) {
            return activeEngagement.engagementStatus.status;
        }
        return null;
    }
    return null;
}

export const scrollTo = (id) => {
    const el = document?.querySelectorAll(`[id=${id}]`)[0]
    el?.scrollIntoView({ behavior: 'smooth' })
};

export const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}

export const resetErrState = (control) => {
    control?.removeAttribute('invalid');
    control?.removeAttribute('aria-invalid');
}

export const setFieldValidity = (field, control, hasError) => {
    console.log(hasError)
    if (hasError) {
        if (!field?.checkValidity?.()) {
            field?.setAttribute('invalid', true);
        }
    } else {
        console.log(control)
        resetErrState(control)
    }
}
